<div class="mat-title">Reviews</div>
<div fxLayout="column" fxLayoutGap="20px">
  <ng-container *ngFor="let review of displayedReviews">
    <ag-review [review]="review" [reviewLength]="reviewLength"></ag-review>
  </ng-container>
  <div fxLayout="row" fxLayoutAlign="center start">
    <button
      *ngIf="displayedReviews.length < reviews.length"
      mat-button
      color="primary"
      class="ag-mat-button-primary"
      type="button"
      (click)="showMoreReviews()"
    >
      See More Reviews
    </button>
  </div>
</div>
